import { Expose, Transform, Type } from 'class-transformer';
import { Model } from './model';
import { Package } from './package-model';
import { PackageType } from '../../common';
import { BaseStudent } from './base-student-model';

export class BalanceReport extends Model {
  @Expose()
  @Type(() => Package)
  package: Package;

  @Expose()
  @Transform(({ value }) => (value ? value.toLowerCase() : null))
  packageType: PackageType;

  @Expose()
  @Type(() => BaseStudent)
  student: BaseStudent;

  @Expose()
  consultantName: string;

  @Expose()
  balanceAmount: string;

  @Expose()
  sessionType: string;
}
